// extracted by mini-css-extract-plugin
export default {"tooltip":"NQ-z","arrow":"OQ-z"};